<template>
    <v-snackbar
      :content-class="CONTENT_CLASS"
      v-model="show"
      :timeout="TIMEOUT"
      :color="COLOR">
      {{ MESSAGE }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="CLOSE"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'Notification',
    data: () => ({
    }),
    methods: {
        onClickClose(){
            this.CLOSE();
            this.$emit('closeNotification');
        },
        ...mapActions('notifications', ['CLOSE']),
    },
    computed:{
      show: {
        get() {
          return this.IS_SHOW;
        },
        set() {
          this.CLOSE();
        }
      },
      ...mapGetters('notifications', ['IS_SHOW', 'COLOR', 'MESSAGE', 'TIMEOUT', 'CONTENT_CLASS']),
    },
}
</script>